<template>
  <div>
    <PageAllow controller="StockIns" action="getShelveOnDetail" />
    <Breadcrumbs :items="items" />
    <v-sheet class="overflow-y-scroll fill-content-height pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              <span class="danger--text">{{
                $t("Material.materialNameWithCodeAndStandard", [
                  stockOnDetail.material_code,
                  stockOnDetail.material_name,
                  stockOnDetail.standard_name,
                ])
              }}</span>
              <span class="danger--text ms-2 pt-1 subtitle-1">{{
                $t("Putaway.DetailFields.wait_putaway_num") +
                $t("Global.colon") +
                stockOnDetail.wait_shelve_on_num_display
              }}</span>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="$permission.permissionAllow('StockIns', 'shelveOn')"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="submitPutaway()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("$vuetify.submit") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.stock_in_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    stockOnDetail.stock_order
                      ? stockOnDetail.stock_order.stock_order_code
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.stock_in_type")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      stockOnDetail.stock_order
                        ? stockOnDetail.stock_order.type_str
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.stock_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockOnDetail.stock_name }}
                </v-card>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.product_date_setting"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.production_date")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="!stockOnDetail.production_date"
                    class="my-n2"
                    v-model="production_date"
                    type="datetime"
                    single-line
                    dense
                    hide-details
                  >
                  </SearcherDatetime>
                  <span v-else>{{ production_date | formatTime }}</span>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.product_date_setting"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.expired_date")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="!stockOnDetail.expired_date"
                    class="my-n2"
                    v-model="expired_date"
                    type="datetime"
                    single-line
                    dense
                    hide-details
                  >
                  </SearcherDatetime>
                  <span v-else>{{ expired_date | formatTime }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.stock_in_created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockOnDetail.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.ext_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    stockOnDetail.stock_order
                      ? stockOnDetail.stock_order.ext_code
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Putaway.DetailFields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockOnDetail.memo }}
                </v-card>
              </v-col>
              <!-- 附件  -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockOrderIN.Fields.attachment_images")}}
                    {{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                          <v-tooltip right v-if="item">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        id="order_details_table"
        :headers="detailsHeaders"
        :items="stockPositions"
        :search="filter"
        disable-sort
        class="elevation-2 px-4 mt-4"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('Putaway.DetailNoData')"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("Putaway.DetailFields.choose_position") }}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-row no-gutters class="me-n3">
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    stockPositions
                      ? [1, stockPositions.length, stockPositions.length]
                      : [0, 0, 0]
                  )
                }}
              </span>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="12" sm="9" md="8">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:header.actions="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.stock_single_unit_num="{ item }">
          <span v-if="$i18n.locale == 'zhHans'">
            {{ item.stock_single_unit_num | formatTwoDot }}
            {{ stockOnDetail.stock_unit }}
          </span>
          <span v-else>
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.stock_single_unit_num | formatTwoDot }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ stockOnDetail.stock_unit }}
            </span>
          </span>
        </template>
        <template v-slot:item.position_num="{ item }">
          <span v-if="$i18n.locale == 'zhHans'">
            {{ item.position_num | formatTwoDot }}
            {{ stockOnDetail.standard.default_standard_detail.unit }}
          </span>
          <span v-else>
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.position_num | formatTwoDot }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ stockOnDetail.standard.default_standard_detail.unit }}
            </span>
          </span>
        </template>
        <template v-slot:item.putaway_num="{ item }">
          <span v-if="stockOnDetail.stock_rate == 1">
            <NumberInput v-model="item.putaway_num" dense>
              <template v-slot:append>
                {{ stockOnDetail.stock_unit }}
              </template>
            </NumberInput>
          </span>
          <span v-else>
            <div class="d-inline-block">
              <NumberInput v-model="item.putaway_num_stock_unit" dense>
                <template v-slot:append>
                  {{ stockOnDetail.stock_unit }}
                </template>
              </NumberInput>
            </div>
            <div class="d-inline-block">
              <NumberInput v-model="item.putaway_num_default_unit" dense>
                <template v-slot:append>
                  {{ stockOnDetail.standard.default_standard_detail.unit }}
                </template>
              </NumberInput>
            </div>
          </span>
        </template>
        <template v-slot:item.putaway_num_stock_unit="{ item }">
          <span v-if="stockOnDetail.stock_rate > 1">
            <div class="d-inline-block">
              <NumberInput v-model="item.putaway_num_stock_unit" dense>
                <template v-slot:append>
                  {{ stockOnDetail.stock_unit }}
                </template>
              </NumberInput>
            </div>
          </span>
        </template>
        <template v-slot:item.putaway_num_default_unit="{ item }">
          <span v-if="stockOnDetail.stock_rate > 1">
            <div class="d-inline-block">
              <NumberInput v-model="item.putaway_num_default_unit" dense>
                <template v-slot:append>
                  {{ stockOnDetail.standard.default_standard_detail.unit }}
                </template>
              </NumberInput>
            </div>
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            small
            text
            class="danger--text pa-0"
            @click.stop="
              stockPositions.splice(
                stockPositions.findIndex(
                  (detail) => item.position_id == detail.position_id
                ),
                1
              )
            "
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </template>

        <template v-slot:footer>
          <v-row no-gutters align="center" class="ps-1 text-no-wrap d-flex">
            <span class="secondary--text">
              {{ $t("CRUD.newInfo", [$t("Position.ObjectName")])
              }}{{ $t("Global.colon") }}
            </span>
            <v-autocomplete
              v-model="addPosition"
              :items="StockPositionSelectItems"
              :loading="stockPositionLoading"
              item-value="id"
              item-text="Description"
              item-disabled="disabled"
              return-object
              clearable
            >
            </v-autocomplete>
          </v-row>
        </template>
      </v-data-table>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Putaway from "@/api/putaway";
import Stocks from "@/api/stocks";
import NumberInput from "@/components/plugins/NumberInput";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import Files from "@/api/files";
import StockIns from "@/api/stock_ins";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    NumberInput,
    SearcherDatetime,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.putaway"),
          disabled: false,
          href: "/putaway",
        },
      ];
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Putaway.DetailFields.position_name"),
          align: "start",
          value: "position_name",
        },
        {
          text: i18n.t("Putaway.DetailFields.position_code"),
          align: "start",
          value: "position_code",
        },
        {
          text: i18n.t("Putaway.DetailFields.postion_lable"),
          align: "center",
          value: "label_name",
        },
        {
          text: i18n.t("Putaway.DetailFields.position_num_with_stock_unit"),
          align: "end",
          value: "stock_single_unit_num",
        },
        {
          text: i18n.t("Putaway.DetailFields.position_num_with_default_unit"),
          align: "end",
          value: "position_num",
        },
      ];
      if (this.$i18n.locale == "zhHans") {
        headers.push({
          text: i18n.t("Putaway.DetailFields.putaway_num"),
          align: "center",
          value: "putaway_num",
        });
      } else {
        headers.push(
          {
            text: i18n.t("Putaway.DetailFields.putaway_num_with_stock_unit"),
            align: "center",
            value: "putaway_num_stock_unit",
          },
          {
            text: i18n.t("Putaway.DetailFields.putaway_num_with_default_unit"),
            align: "center",
            value: "putaway_num_default_unit",
          }
        );
      }

      headers.push({
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      });

      return headers;
    },
    StockPositionSelectItems() {
      return this.stockPositionSelect.map((position_select) => {
        let disabledItem = this.stockPositions.find(
          (position) =>
            !position_select.disabled &&
            position.position_id == position_select.id
        );
        if (disabledItem) {
          position_select.disabled = true;
        }
        return position_select;
      });
    },
    ...mapState(["settings"]),
  },

  data: () => ({
    panels: [0],
    filter: "",
    stockOnDetail: [],
    stockPositions: [],
    stockPositionSelect: [],
    stockPositionLoading: false,
    addPosition: null,
    production_date: "",
    expired_date: "",
    album: [],
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value || value.filter((v) => v.size >= 10000000).length == 0 || i18n.t("Material.imgsHint"),
    ],
  }),

  mounted() {
    Putaway.fetchOne(this.$route.params.id).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.stockOnDetail = response.data.shelve_on_detail;
          this.production_date = this.stockOnDetail.production_date;
          this.expired_date = response.data.shelve_on_detail.expired_date;
          this.album = response.data.shelve_on_detail.stock_order.img
          this.stockOnDetail.stock_order.type_str =
            this.$consts.stock_in_order.types.find(
              (element) => element.value == this.stockOnDetail.stock_order.type
            ).text;
          if (response.data.stock_positions.length) {
            this.stockPositions = response.data.stock_positions;
            //换算待上架数量
            let newFields = {
              putaway_num: this.stockOnDetail.wait_shelve_on_num,
              putaway_num_stock_unit: "",
              putaway_num_default_unit: "",
            };
            if (this.stockOnDetail.stock_rate > 1) {
              newFields.putaway_num_stock_unit = parseInt(
                this.stockOnDetail.wait_shelve_on_num /
                  this.stockOnDetail.stock_rate
              );
              newFields.putaway_num_default_unit =
                this.stockOnDetail.wait_shelve_on_num %
                this.stockOnDetail.stock_rate;
            }

            //将待上架数量默认填充到推荐的第一个库位上
            this.stockPositions[0] = Object.assign(
              {},
              this.stockPositions[0],
              newFields
            );
          }

          //库位下拉框
          if (response.data.stock_position_select.length) {
            this.stockPositionSelect = response.data.stock_position_select;
            Stocks.fetchOne(
              response.data.shelve_on_detail.stock_order.stock_id
            ).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let positionNameDisplayFormat =
                    response.data.stock.position_name_display;
                  this.stockPositionSelect = this.stockPositionSelect.map(
                    (item) => {
                      var Description = i18n.t(
                        "MovePositionOrder.DetailFields.position",
                        [item.position_code, item.position_name]
                      );
                      if (positionNameDisplayFormat) {
                        if (positionNameDisplayFormat.indexOf(2) > -1) {
                          Description = item.position_name;
                        }
                        if (
                          positionNameDisplayFormat.indexOf(4) > -1 &&
                          item.stock_roadway
                        ) {
                          Description =
                            item.stock_roadway.code + " - " + Description;
                        }
                        if (
                          positionNameDisplayFormat.indexOf(3) > -1 &&
                          item.stock_area
                        ) {
                          Description =
                            item.stock_area.area_name + " - " + Description;
                        }
                      }
                      Description = Description + "（" + item.label_name + "）";

                      return Object.assign({}, item, { Description });
                    }
                  );
                }
              }.bind(this)
            );
          }
        }
      }.bind(this)
    );
  },

  methods: {
    submitPutaway() {
      this.$store.dispatch("fullscreenLoading");
      this.submitUploadImg()
      var isSubmit = 1; //是否可提交上架flg
      //判断是否开启了强制保质期
      if (this.settings.material_force_bestbefore) {
        var expired_date_empty = 0;
        var production_date_empty = 0;
        if (!this.production_date) {
          production_date_empty = 1;
        }
        if (!this.expired_date) {
          expired_date_empty = 1;
        } else {
          if (!this.production_date) {
            if (this.stockOnDetail.material.stock_batch_rule_type == 2) {
              production_date_empty = 0;
              this.production_date =
                new Date(
                  new Date(this.expired_date).getTime() -
                    this.stockOnDetail.material.bestbefore * 24 * 3600 * 1000
                )
                  .toISOString()
                  .substr(0, 10) + " 00:00:00";
            } else {
              production_date_empty = 1;
            }
          }
        }
        if (production_date_empty) {
          isSubmit = 0; //有报错不可提交
          this.$snackbar.error(i18n.t("Putaway.productionDateRequired"));
          this.$store.dispatch("fullscreenLoadingStop");
        }
        if (expired_date_empty) {
          isSubmit = 0; //有报错不可提交
          this.$snackbar.error(i18n.t("Putaway.expiredDateRequired"));
          this.$store.dispatch("fullscreenLoadingStop");
        }
      }
      if (isSubmit) {
        var in_details = [
          {
            id: this.stockOnDetail.id,
            production_date: this.production_date,
            expired_date: this.expired_date,
            positions: [],
          },
        ];
        
        this.stockPositions.forEach((position) => {
          //大单位小单位时换算上架数量
          // var position_num = 0;
          // if (this.stockOnDetail.stock_rate > 1) {
          //   if (position.putaway_num_stock_unit)
          //     position_num =
          //       position.putaway_num_stock_unit * this.stockOnDetail.stock_rate;
          //   if (position.putaway_num) position_num += position.putaway_num;
          // } else {
          //   position_num = position.putaway_num;
          // }

          if (position.putaway_num > 0) {
            in_details[0].positions.push({
              stock_position_id: position.position_id,
              position_num: position.putaway_num,
            });
          }
        });

        if (in_details[0].positions.length) {
          //判断上架数量是否超出
          var position_num_count = 0;
          in_details[0].positions.forEach((position) => {
            position_num_count += Number(position.position_num);
          });

          if (position_num_count > this.stockOnDetail.wait_shelve_on_num) {
            this.$snackbar.error(i18n.t("Putaway.putawayNumMax"));
            this.$store.dispatch("fullscreenLoadingStop");
          } else {
            Putaway.submit({
              stock_order_id: this.stockOnDetail.stock_order_id,
              in_details: in_details,
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  this.$router.replace("/putaway");
                }
              }.bind(this)
            );
          }
        } else {
          this.$snackbar.error(i18n.t("Putaway.putawayNumRequired"));
          this.$store.dispatch("fullscreenLoadingStop");
        }
      }
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var stock_in_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file, false, "images"
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => stock_in_img.push(img.img_name));
          StockIns.update({
            id: this.stockOnDetail.stock_order_id,
            img: stock_in_img,
          }).then(
            function () {
            }.bind(this)
          ).catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
        }
      }
      if (this.imgs_file.length == 0 && this.album.length == 0) {
        StockIns.update({
          id: this.stockOnDetail.stock_order_id,
          img_del_flg: 1,
        }).then(
          function () {}.bind(this)
        ).catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
  },

  watch: {
    addPosition: {
      handler() {
        if (this.addPosition && this.addPosition.id) {
          this.stockPositions.push({
            position_id: this.addPosition.id,
            position_name: this.addPosition.position_name,
            position_code: this.addPosition.position_code,
            label_name: this.addPosition.label_name,
            position_num: this.addPosition.position_num,
            putaway_num: "",
            putaway_num_stock_unit: "",
            putaway_num_default_unit: "",
          });
          this.addPosition = {
            id: 0,
            position_code: "",
            position_name: "",
          }; //消除显示
        }
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length > 0) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.stockOnDetail.stock_order.img ? this.stockOnDetail.stock_order.img : [];
        }
      },
    },
  },
};
</script>